import type {
  GpsPermissionLevel,
  HomeGeofenceConfig,
  LocationCaptureConfig,
  LocationSyncCallbacks
} from './location-sync.native';

export type {
  GpsPermissionLevel,
  HomeGeofenceConfig,
  LocationCaptureConfig,
  LocationSyncCallbacks
};

/** Web/no-op stub — background location capture is native-only. */
class LocationSync {
  async configure(
    _captureConfig: LocationCaptureConfig,
    _callbacks?: LocationSyncCallbacks,
    _homeGeofence?: HomeGeofenceConfig | null
  ): Promise<void> {
    return undefined;
  }
  async ensureTracking(_level?: GpsPermissionLevel): Promise<boolean> {
    return false;
  }
  async stop(): Promise<void> {
    return undefined;
  }
  isStarted(): boolean {
    return false;
  }
  async checkin(
    _level: GpsPermissionLevel,
    _batteryLevel?: number | null
  ): Promise<void> {
    return undefined;
  }
  async getPermissionLevel(): Promise<GpsPermissionLevel> {
    return 'unknown';
  }
  async requestPermission(): Promise<GpsPermissionLevel> {
    return 'unknown';
  }
}

export default new LocationSync();
